module.exports = __webpack_public_path__ + "static/media/lightning_mcqueen.635eceab.jpg";